






























































































import { Vue, Component } from 'vue-property-decorator';
import Sticky from 'vue-sticky-directive';
import {
  UserApi, User, Partner,
} from '@compassdigital/foodworks.ts.sdk';
import AppModule from '@/store/modules/app';
import PartnerUtil from '@/util/PartnerUtil';
import ContactInformationEdit from '@/components/Form/Partner/ContactInformationEdit/index.vue';
import RestaurantInformationEdit from '@/components/Form/Partner/RestaurantInformationEdit/index.vue';
import PrimaryButton from '@/components/Buttons/PrimaryButton/index.vue';
import UserModule from '@/store/modules/user';
import lifecycle from '@/store/modules/lifecycle';

@Component({
  components: {
    ContactInformationEdit,
    RestaurantInformationEdit,
    PrimaryButton,
  },
  directives: { Sticky },
})
export default class ReviewInformation extends Vue {
  private newContactInfo: User | null = null;

  public partnerID: string = '';

  get contactInfo() {
    if (this.newContactInfo) {
      return this.newContactInfo;
    }
    if (UserModule.currentPartner && UserModule.currentPartner.id) {
      return this.getContactInformation();
    }
    return null;
  }

  public async getContactInformation() {
    if (UserModule.currentPartner && UserModule.currentPartner.id) {
      try {
        const { ownerUserId } = UserModule.currentPartner!;
        this.partnerID = UserModule.currentPartner.id;
        const api = new UserApi(AppModule.apiConfig);
        const user = await api.getUser((ownerUserId as string));
        ((this.newContactInfo) as any) = PartnerUtil.mappedOnboardingUser(user.data);
        return this.newContactInfo;
      } catch (error) {
        //
      }
    }
    return '';
  }

  set contactInfo(v) {
    if (v) {
      ((this.newContactInfo as any)) = v;
    }
  }

  private newRestaurantInfo: Partner | null = null;

  get restaurantInfo() {
    if (this.newRestaurantInfo) {
      return this.newRestaurantInfo;
    }
    if (UserModule.currentPartner && UserModule.currentPartner.id) {
      return PartnerUtil.getMappedOnboardingUser(UserModule.currentPartner);
    }
    return null;
  }

  set restaurantInfo(v) {
    if (v) {
      this.newRestaurantInfo = v;
    }
  }

  private loading: boolean = false;

  private async saveLogout() {
    lifecycle.terminate();
    this.$router.push('/login');
  }

  // Routes home with params
  public confirmation() {
    this.$router.push({ name: 'application/forms' });
  }
}
